import {
  HIDE_INFO_MODAL,
  HIDE_LOADER,
  HIDE_MISC_MODAL,
  NEXT_STEP,
  PREVIOUS_STEP,
  SHOW_INFO_MODAL,
  SHOW_LOADER,
  SHOW_MISC_MODAL,
  UPLOAD_IMAGE,
} from "./actionTypes";
import axios from "axios";

export const nextStep = () => ({
  type: NEXT_STEP,
});

export const previousStep = () => ({
  type: PREVIOUS_STEP,
});

export const showInfoModal = (type, content) => ({
  type: SHOW_INFO_MODAL,
  payload: { type, content },
});

export const hideInfoModal = () => ({
  type: HIDE_INFO_MODAL,
});

export const showMiscModal = (type, content) => ({
  type: SHOW_MISC_MODAL,
  payload: { type, content },
});

export const hideMiscModal = () => ({
  type: HIDE_MISC_MODAL,
});

export const showLoader = () => ({
  type: SHOW_LOADER,
});

export const hideLoader = () => ({
  type: HIDE_LOADER,
});

export const uploadImage = (img) => (dispatch) => {
  const formData = new FormData();
  formData.append("file", img);
  formData.append("api_key", "521249556881761");
  formData.append("upload_preset", "zyc1sarr");
  let config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "POST",
      // "X-Requested-With": "XMLHttpRequest",
      // "Access-Control-Allow-Headers": "*",
    },
  };
  axios
    .post("https://api.cloudinary.com/v1_1/dcbg9lnle/upload", formData)
    .then((res) => {
      dispatch({
        type: UPLOAD_IMAGE,
        payload: res.data.url,
      });
      dispatch(hideLoader());
    })
    .catch((err) => {
      console.log("err", err);
    });
};
